import styled from 'styled-components';

import Dialog from '../Dialog';

export const FolderTreeWrapper = styled(Dialog)`
  max-width: 500px;
  width: calc(100% - 30px);
  padding: 0;
`;

export const ModalHeader = styled.header`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  padding: 25px 10px 15px;
  border-bottom: 1px solid rgba(55, 61, 63, 0.1);
  max-height: calc(100vh - 60px);
`;

export const ModalMain = styled.main`
  height: 415px;
  overflow-y: auto;
  padding: 10px;
`;

export const ModalFooter = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid rgba(55, 61, 63, 0.1);
  padding: 20px 30px;
`;
